<div [ngClass]="{'mar-right-0': ifGameDemo}" class="quick_links" id="hearderMainDiv">
  <!-- TODO Commented based on Niraj comment and keep it for future if needed
  <a href="#" class="help_link gtmHelp">
    <img alt="click here for help" />
    &nbsp; {{help}}
  </a> -->
  <div ngbDropdown #myDrop="ngbDropdown" class="d-inline-block" display="dynamic" placement="bottom-right" id="myDrop">
    <a id="language" class="gtmLanguage" ngbDropdownToggle [innerHTML]="buttonText">

      &nbsp; <span [innerHTML]="language"></span>
    </a>
    <div [ngClass]="{'resizeForm':isRussian ,'dropdown-menu':!isRussian}" ngbDropdownMenu aria-labelledby="language" id="dropDownMenu">
      <div class="dropdown-menu_header language_heading" id="dropDownHeader">
        <img class="lang_image" alt="select language">&nbsp;
        <h5 [innerHTML]="languageText"></h5>
      </div>
      <form [formGroup]="headerForm" class="dropdownscroll" ngbRadioGroup>
        <div id="headerFrm">
          <label ngbButtonLabel for="language"  [ngClass] ="browserLanguage === 'tr' ? 'lang_radiobtn_turkish' : 'lang_radiobtn'"
            *ngFor="let language of languageJSON; trackBy: trackByLanguage">
            {{ language.langName }}
            <input type="radio" name="lang" value="language.langName"
              (click)="setButtonText(language.langName, language.langCode)" [checked]="language.checked" />
          </label>
        </div>
      </form>
      <div class="dropdown-menu_footer" id="dropDownFooter">
        <button type="submit" class="btn btn-outline-primary" [innerHTML]="cancel"
          (click)="$event.stopPropagation();cancelSelection(); myDrop.close();"></button>
        <button type="submit" class="btn btn-primary" [innerHTML]="selectLanguage"
          (click)="$event.stopPropagation();getButtonText(); myDrop.close();"></button>
      </div>
    </div>
  </div>

</div>
